<div class="book-call-widget">
  <button
    class="book-call-button"
    (click)="onBookCallClick()">
    <img class="phone-icon" [src]="baseHref + 'assets/images/screencasts/phone_icon.svg'" alt="Phone">
    <span>{{ label | translate | uppercase }}</span>
  </button>
</div>
